import { ownValue } from "../record";
import { cartSchema } from "./cart";
import { keyboardSchema } from "./keyboard";
import { loyaltyAuthSchema } from "./loyaltyAuth";
import { mainSchema } from "./main";
import { orderTypeSchema } from "./orderType";
import { productCardSchema } from "./productCard";
import type { DecorationElementSchema, DecorationSchema } from "./types";

export type {
	DecorationElementSchema,
	DecorationLayoutsSchema,
	DecorationLimitSchema,
	DecorationSchema,
	DecorationScreenSchema,
	DecorationVariantSchema,
} from "./types";

export const decorationSchema = {
	main: mainSchema,
	product_card: productCardSchema,
	cart: cartSchema,
	loyalty_auth: loyaltyAuthSchema,
	keyboard: keyboardSchema,
	order_type: orderTypeSchema,
} as const satisfies DecorationSchema;

export const INSERT_NAME = /^ins_\d{13}$/;

export const LAYOUT_NAME = /^[a-z0-9_]{1,40}$/;

const screens: DecorationSchema = decorationSchema;

export const elementSchemaOf = (screen: string, element: string): DecorationElementSchema | undefined => ownValue(ownValue(screens, screen), element);
